import { useCallback } from "react";
import { FlowActions } from "../../stores/flowStore";
export const useAuthenticateFlow = () => {
  return _temp;
};
function _temp(t0) {
  const {
    onAuthenticated,
    autoPromptSiwe: t1
  } = t0 === undefined ? {} : t0;
  const autoPromptSiwe = t1 === undefined ? false : t1;
  FlowActions.startFlow({
    type: "authenticate",
    onAuthenticated,
    autoPromptSiwe
  });
}